import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

export const OTReportCalender = ({
  selectionRange,
  setSelectionRange,
  onClose,
}) => {
  const handleDateSelect = (date) => {
    setSelectionRange({ startDate: date, endDate: date, key: "selection" });
    onClose();
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateCalendar
        value={selectionRange.startDate}
        onChange={handleDateSelect}
        sx={{
          backgroundColor: "var(--cell-bg-color)",
          borderRadius: 2,
          "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#12b79f",
            color: "#fff",
          },
        }}
      />
    </LocalizationProvider>
  );
};
